import React from 'react';
import QA from "../qa/QA";
import {useTranslation} from "react-i18next";
import "./QAcomponent.css"
const QAComponents = () => {

    const {t} = useTranslation();


    const qaData = [
        {
            title: t('ხშირად დასმული კითხვები'),
            description: t('ნაგებობის მიწის ნაკვეთის სამშენებლოდ გამოყენების პირობები, პროექტი.'),
            link: '/qa',
            linkName: t('გაიგე მეტი'),
            openTaxCalculator: false
        },
        {
            title: t('მოსაკრებელის კალკულატორი'),
            description: t('განსაკუთრებული მნიშვნელობისა და სტრატეგიული დანიშნულების ობიექტების მშენებლობის ნებართვის მოსაკრებელის გამოთვლა'),
            link: 'https://example.com/2',
            linkName: t('კონტაქტი'),
            openTaxCalculator: true

        },
        {
            title: t('სასარგებლო ინფორმაცია'),
            description: t('ნაგებობის მიწის ნაკვეთის სამშენებლოდ გამოყენების პირობები, პროექტი.'),
            link: 'pages/development',
            linkName: t('გაიგე მეტი'),
            openTaxCalculator: false

        },
    ];


    return (
        <div className={"qaa-container"}>
            <div className={"qaa-wrapper"}>
                {qaData.map((qa, index) => (
                    <QA
                        key={index}
                        title={qa.title}
                        description={qa.description}
                        link={qa.link}
                        linkName={qa.linkName}
                        openTaxCalculator={qa.openTaxCalculator}
                    />
                ))}
            </div>
        </div>
    );
};

export default QAComponents;
